import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'verifiedCallerIds';
var crud = createCrud(basePath);

/* Default queries */
export var useVerifiedCallerIdById = crud.makeFindById();
export var useVerifiedCallerIdMany = crud.makeFindMany();

/* Default mutations */
export var useVerifiedCallerIdCreateOne = crud.makeCreateOne();
export var useVerifiedCallerIdUpdateOne = crud.makeUpdateOne();
export var useVerifiedCallerIdRemoveById = crud.makeRemoveById();